import { useState, useEffect } from "react";
import axios from "axios";
import { Plus, Edit, Trash2, Save, X, TrendingUp } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminPage = () => {
  const [activeTab, setActiveTab] = useState("categories");
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [tables, setTables] = useState([]);
  const [staff, setStaff] = useState([]);
  const [extras, setExtras] = useState([]); // Extra ingredients
  
  const [editingItem, setEditingItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({});
  
  // For bulk price increase
  const [showPriceIncreaseModal, setShowPriceIncreaseModal] = useState(false);
  const [priceIncreasePercentage, setPriceIncreasePercentage] = useState("");
  
  // For extras bulk price increase
  const [showExtrasPriceIncreaseModal, setShowExtrasPriceIncreaseModal] = useState(false);
  const [extrasPriceIncreasePercentage, setExtrasPriceIncreasePercentage] = useState("");
  
  // For save button loading
  const [isSaving, setIsSaving] = useState(false);
  
  // For ingredients and sizes management
  const [currentIngredient, setCurrentIngredient] = useState("");
  const [currentExtra, setCurrentExtra] = useState("");
  const [currentSize, setCurrentSize] = useState({ name: "", price: "" });

  useEffect(() => {
    loadData();
  }, [activeTab]);

  const loadData = async () => {
    try {
      console.log(`[AdminPage] loadData başladı, activeTab: ${activeTab}`);
      console.log(`[AdminPage] BACKEND_URL: ${BACKEND_URL}`);
      console.log(`[AdminPage] API: ${API}`);
      
      switch(activeTab) {
        case "categories":
          const catRes = await axios.get(`${API}/categories`);
          setCategories(catRes.data);
          break;
        case "products":
          const prodRes = await axios.get(`${API}/products`);
          setProducts(prodRes.data);
          const catRes2 = await axios.get(`${API}/categories`);
          setCategories(catRes2.data);
          const extrasRes = await axios.get(`${API}/extras`);
          setExtras(extrasRes.data);
          break;
        case "tables":
          console.log(`[AdminPage] Masalar yükleniyor: ${API}/tables`);
          const tableRes = await axios.get(`${API}/tables`);
          console.log(`[AdminPage] Masalar yüklendi, sayı: ${tableRes.data.length}`);
          setTables(tableRes.data);
          break;
        case "staff":
          const staffRes = await axios.get(`${API}/staff`);
          setStaff(staffRes.data);
          break;
        case "extras":
          const extrasRes2 = await axios.get(`${API}/extras`);
          setExtras(extrasRes2.data);
          break;
      }
    } catch (error) {
      console.error("[AdminPage] Veri yükleme hatası:", error);
      console.error("[AdminPage] Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url
      });
      alert(`Veri yükleme hatası: ${error.response?.data?.detail || error.message}`);
    }
  };

  const openAddModal = () => {
    setEditingItem(null);
    if (activeTab === "products") {
      setFormData({ ingredients: [], extra_ids: [], sizes: [] });
    } else {
      setFormData({});
    }
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setEditingItem(item);
    if (activeTab === "products") {
      setFormData({
        ...item,
        ingredients: item.ingredients || [],
        extra_ids: item.extra_ids || [],
        sizes: item.sizes || []
      });
    } else {
      setFormData(item);
    }
    setShowModal(true);
  };

  const handleSave = async () => {
    if (isSaving) return; // Prevent double submission
    
    console.log("handleSave başladı, activeTab:", activeTab);
    console.log("formData:", formData);
    
    // Validation
    if (activeTab === "products" && !formData.name) {
      alert("Ürün adı gereklidir!");
      return;
    }
    if (activeTab === "products" && !formData.category_id) {
      alert("Kategori seçilmelidir!");
      return;
    }
    // Fiyat kontrolü: Eğer boyutlar varsa price zorunlu değil, yoksa zorunlu
    if (activeTab === "products") {
      const hasSizes = formData.sizes && formData.sizes.length > 0;
      const hasPrice = formData.price && formData.price > 0;
      
      if (!hasSizes && !hasPrice) {
        alert("Boyut ekleyin veya temel fiyat giriniz!");
        return;
      }
    }
    
    setIsSaving(true);
    try {
      const url = editingItem 
        ? `${API}/${activeTab}/${editingItem.id}`
        : `${API}/${activeTab}`;
      
      console.log("[AdminPage] API isteği:", editingItem ? "PUT" : "POST", url);
      console.log("[AdminPage] Gönderilen data:", formData);
      console.log("[AdminPage] BACKEND_URL:", BACKEND_URL);
      console.log("[AdminPage] ActiveTab:", activeTab);
      
      if (editingItem) {
        // Update
        const response = await axios.put(url, formData);
        console.log("[AdminPage] Güncelleme başarılı:", response.data);
      } else {
        // Create
        const response = await axios.post(url, formData);
        console.log("[AdminPage] Ekleme başarılı:", response.data);
      }
      
      console.log("[AdminPage] Modal kapatılıyor ve veriler yeniden yükleniyor...");
      setShowModal(false);
      setFormData({});
      await loadData();
      console.log("[AdminPage] İşlem tamamlandı!");
      
    } catch (error) {
      console.error("[AdminPage] Kaydetme hatası:", error);
      console.error("[AdminPage] Error response:", error.response);
      console.error("[AdminPage] Error details:", {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
        url: error.config?.url
      });
      
      if (error.response?.data?.detail) {
        alert(`Hata: ${error.response.data.detail}`);
      } else {
        alert(`Hata oluştu: ${error.message}\n\nDetay: ${error.response?.status || 'Bilinmiyor'}`);
      }
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (id) => {
    console.log("handleDelete çağrıldı, id:", id, "activeTab:", activeTab);
    
    if (!window.confirm("Silmek istediğinize emin misiniz?")) {
      console.log("Kullanıcı silme işlemini iptal etti");
      return;
    }
    
    try {
      const url = `${API}/${activeTab}/${id}`;
      console.log("Silme isteği gönderiliyor:", url);
      
      const response = await axios.delete(url);
      console.log("Silme yanıtı:", response.data);
      
      loadData();
    } catch (error) {
      console.error("Silme hatası:", error);
      console.error("Error response:", error.response);
      alert("Hata oluştu!");
    }
  };
  
  const handleBulkPriceIncrease = async () => {
    const percentage = parseFloat(priceIncreasePercentage);
    console.log("Toplu zam başladı, percentage:", percentage);
    
    if (isNaN(percentage) || percentage <= 0) {
      alert("Geçerli bir yüzde değeri girin!");
      return;
    }
    
    if (!window.confirm(`Tüm ürün fiyatlarını %${percentage} artırmak istediğinize emin misiniz?`)) {
      return;
    }
    
    try {
      console.log("API isteği gönderiliyor:", `${API}/products/bulk-price-increase`);
      console.log("Data:", { percentage });
      
      const response = await axios.post(`${API}/products/bulk-price-increase`, {
        percentage: percentage
      });
      
      console.log("Zam yanıtı:", response.data);
      alert(response.data.message);
      setShowPriceIncreaseModal(false);
      setPriceIncreasePercentage("");
      if (activeTab === "products") {
        loadData();
      }
    } catch (error) {
      console.error("Toplu zam hatası:", error);
      console.error("Error response:", error.response);
      alert("Hata oluştu!");
    }
  };
  
  // Ingredient management
  const addIngredient = () => {
    if (currentIngredient.trim()) {
      setFormData({
        ...formData,
        ingredients: [...formData.ingredients, currentIngredient.trim()]
      });
      setCurrentIngredient("");
    }
  };

  const handleExtrasBulkPriceIncrease = async () => {
    const percentage = parseFloat(extrasPriceIncreasePercentage);
    
    if (isNaN(percentage) || percentage <= 0) {
      alert("Geçerli bir yüzde değeri girin!");
      return;
    }
    
    if (!window.confirm(`Tüm extra malzeme fiyatlarını %${percentage} artırmak istediğinize emin misiniz?\n\nFiyatlar akıllı yuvarlanacak:\n- Son rakam 1-4: Aşağı yuvarla (152→150)\n- Son rakam 5: Olduğu gibi (155→155)\n- Son rakam 6-9: Yukarı yuvarla (158→160)`)) {
      return;
    }
    
    try {
      const response = await axios.post(`${API}/extras/bulk-price-increase`, {
        percentage: percentage
      });
      
      alert(response.data.message);
      setShowExtrasPriceIncreaseModal(false);
      setExtrasPriceIncreasePercentage("");
      if (activeTab === "extras") {
        loadData();
      }
    } catch (error) {
      console.error("Extra malzeme zam hatası:", error);
      alert("Hata oluştu: " + (error.response?.data?.detail || "Bilinmeyen hata"));
    }
  };

  const removeIngredient = (index) => {
    const newIngredients = [...formData.ingredients];
    newIngredients.splice(index, 1);
    setFormData({ ...formData, ingredients: newIngredients });
  };
  
  // Extra IDs management (multi-select)
  const toggleExtraId = (extraId) => {
    const currentExtraIds = formData.extra_ids || [];
    if (currentExtraIds.includes(extraId)) {
      setFormData({
        ...formData,
        extra_ids: currentExtraIds.filter(id => id !== extraId)
      });
    } else {
      setFormData({
        ...formData,
        extra_ids: [...currentExtraIds, extraId]
      });
    }
  };
  
  // Size management
  const addSize = () => {
    if (currentSize.name.trim() && currentSize.price) {
      setFormData({
        ...formData,
        sizes: [...(formData.sizes || []), { 
          name: currentSize.name.trim(), 
          price: parseFloat(currentSize.price) 
        }]
      });
      setCurrentSize({ name: "", price: "" });
    }
  };
  
  const removeSize = (index) => {
    const newSizes = [...formData.sizes];
    newSizes.splice(index, 1);
    setFormData({ ...formData, sizes: newSizes });
  };

  const renderForm = () => {
    switch(activeTab) {
      case "categories":
        return (
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Kategori Adı"
              value={formData.name || ""}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            />
            <input
              type="number"
              placeholder="Sıra"
              value={formData.order || 0}
              onChange={(e) => setFormData({...formData, order: parseInt(e.target.value)})}
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
        );
      case "products":
        return (
          <div className="space-y-4 max-h-[70vh] overflow-y-auto">
            <input
              type="text"
              placeholder="Ürün Adı"
              value={formData.name || ""}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            />
            <select
              value={formData.category_id || ""}
              onChange={(e) => setFormData({...formData, category_id: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            >
              <option value="">Kategori Seçin</option>
              {categories.map(cat => (
                <option key={cat.id} value={cat.id}>{cat.name}</option>
              ))}
            </select>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Temel Fiyat (₺) <span className="text-gray-400 text-xs">(Boyut yoksa zorunlu)</span>
              </label>
              <input
                type="number"
                step="0.01"
                placeholder="Boyut kullanıyorsanız boş bırakabilirsiniz"
                value={formData.price || ""}
                onChange={(e) => setFormData({...formData, price: parseFloat(e.target.value)})}
                className="w-full px-4 py-2 border rounded-lg"
              />
            </div>
            
            {/* Sizes Section */}
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
              <h3 className="font-bold mb-2 text-gray-700">Boyutlar (Küçük, Orta, Büyük)</h3>
              <p className="text-xs text-gray-500 mb-3">Pizza gibi ürünler için boyut ve fiyat ekleyin</p>
              
              <div className="flex space-x-2 mb-3">
                <input
                  type="text"
                  placeholder="Boyut adı (örn: Küçük)"
                  value={currentSize.name}
                  onChange={(e) => setCurrentSize({...currentSize, name: e.target.value})}
                  className="flex-1 px-3 py-2 border rounded-lg text-sm"
                />
                <input
                  type="number"
                  step="0.01"
                  placeholder="Fiyat"
                  value={currentSize.price}
                  onChange={(e) => setCurrentSize({...currentSize, price: e.target.value})}
                  className="w-24 px-3 py-2 border rounded-lg text-sm"
                />
                <button
                  type="button"
                  onClick={addSize}
                  className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
                >
                  <Plus size={16} />
                </button>
              </div>
              
              {formData.sizes && formData.sizes.length > 0 && (
                <div className="space-y-2">
                  {formData.sizes.map((size, idx) => (
                    <div key={idx} className="flex justify-between items-center bg-gray-100 px-3 py-2 rounded">
                      <span className="text-sm">{size.name}: {size.price} ₺</span>
                      <button
                        type="button"
                        onClick={() => removeSize(idx)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <X size={16} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            {/* Ingredients Section */}
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
              <h3 className="font-bold mb-2 text-gray-700">Malzemeler</h3>
              <p className="text-xs text-gray-500 mb-3">Ürünün varsayılan malzemelerini ekleyin</p>
              
              <div className="flex space-x-2 mb-3">
                <input
                  type="text"
                  placeholder="Malzeme adı"
                  value={currentIngredient}
                  onChange={(e) => setCurrentIngredient(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && addIngredient()}
                  className="flex-1 px-3 py-2 border rounded-lg text-sm"
                />
                <button
                  type="button"
                  onClick={addIngredient}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                >
                  <Plus size={16} />
                </button>
              </div>
              
              {formData.ingredients && formData.ingredients.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {formData.ingredients.map((ing, idx) => (
                    <div key={idx} className="flex items-center space-x-2 bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                      <span>{ing}</span>
                      <button
                        type="button"
                        onClick={() => removeIngredient(idx)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <X size={14} />
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            
            {/* Extra Ingredients Section - Multi Select */}
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
              <h3 className="font-bold mb-2 text-gray-700">Ekstra Malzemeler</h3>
              <p className="text-xs text-gray-500 mb-3">Müşterilerin ekleyebileceği ekstra malzemeleri seçin</p>
              
              {extras.length === 0 ? (
                <p className="text-sm text-gray-500 italic">Henüz ekstra malzeme eklenmemiş. "Ekstra Malzemeler" sekmesinden ekleyin.</p>
              ) : (
                <div className="grid grid-cols-2 gap-2">
                  {extras.map((extra) => (
                    <button
                      key={extra.id}
                      type="button"
                      onClick={() => toggleExtraId(extra.id)}
                      className={`px-3 py-2 rounded-lg border-2 text-sm transition ${
                        (formData.extra_ids || []).includes(extra.id)
                          ? "border-green-500 bg-green-50 text-green-800"
                          : "border-gray-200 hover:border-gray-300 bg-white"
                      }`}
                    >
                      {(formData.extra_ids || []).includes(extra.id) && "✓ "}
                      {extra.name}
                    </button>
                  ))}
                </div>
              )}
            </div>
            
            <input
              type="text"
              placeholder="Resim URL (opsiyonel)"
              value={formData.image_url || ""}
              onChange={(e) => setFormData({...formData, image_url: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            />
            <textarea
              placeholder="Açıklama"
              value={formData.description || ""}
              onChange={(e) => setFormData({...formData, description: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg h-24"
            />
          </div>
        );
      case "tables":
        return (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Masa Numarası</label>
              <input
                type="text"
                placeholder="Masa numarası (örn: B1, Y1, 15)"
                value={formData.number || ""}
                onChange={(e) => setFormData({...formData, number: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg"
              />
              <p className="text-xs text-gray-500 mt-1">Harf+rakam formatında girebilirsiniz (B1, Y1) veya sadece rakam (15)</p>
            </div>
            <input
              type="number"
              placeholder="Kapasite"
              value={formData.capacity || ""}
              onChange={(e) => setFormData({...formData, capacity: parseInt(e.target.value)})}
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
        );
      case "staff":
        return (
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Personel Adı"
              value={formData.name || ""}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            />
            <select
              value={formData.role || ""}
              onChange={(e) => setFormData({...formData, role: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            >
              <option value="">Rol Seçin</option>
              <option value="garson">Garson</option>
              <option value="kasiyer">Kasiyer</option>
              <option value="şef">Şef</option>
              <option value="yönetici">Yönetici</option>
            </select>
            <input
              type="tel"
              placeholder="Telefon"
              value={formData.phone || ""}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            />
          </div>
        );
      case "extras":
        return (
          <div className="space-y-4">
            <input
              type="text"
              placeholder="Ekstra Malzeme Adı (örn: Mantar)"
              value={formData.name || ""}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              className="w-full px-4 py-2 border rounded-lg"
            />
            
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4">
              <h3 className="font-bold mb-3 text-gray-700">Boyut Bazlı Fiyatlandırma</h3>
              <p className="text-xs text-gray-500 mb-3">Farklı pizza boyutları için farklı fiyatlar belirleyin</p>
              
              <div className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Küçük Boy Fiyat (₺)</label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="20.00"
                    value={formData.size_prices?.find(sp => sp.size === "küçük")?.price || ""}
                    onChange={(e) => {
                      const sizePrices = formData.size_prices || [];
                      const filtered = sizePrices.filter(sp => sp.size !== "küçük");
                      setFormData({
                        ...formData, 
                        size_prices: [...filtered, { size: "küçük", price: parseFloat(e.target.value) || 0 }]
                      });
                    }}
                    className="w-full px-4 py-2 border rounded-lg"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Orta Boy Fiyat (₺)</label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="40.00"
                    value={formData.size_prices?.find(sp => sp.size === "orta")?.price || ""}
                    onChange={(e) => {
                      const sizePrices = formData.size_prices || [];
                      const filtered = sizePrices.filter(sp => sp.size !== "orta");
                      setFormData({
                        ...formData, 
                        size_prices: [...filtered, { size: "orta", price: parseFloat(e.target.value) || 0 }]
                      });
                    }}
                    className="w-full px-4 py-2 border rounded-lg"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Büyük Boy Fiyat (₺)</label>
                  <input
                    type="number"
                    step="0.01"
                    placeholder="60.00"
                    value={formData.size_prices?.find(sp => sp.size === "büyük")?.price || ""}
                    onChange={(e) => {
                      const sizePrices = formData.size_prices || [];
                      const filtered = sizePrices.filter(sp => sp.size !== "büyük");
                      setFormData({
                        ...formData, 
                        size_prices: [...filtered, { size: "büyük", price: parseFloat(e.target.value) || 0 }]
                      });
                    }}
                    className="w-full px-4 py-2 border rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        );
    }
  };

  const renderList = () => {
    let data = [];
    switch(activeTab) {
      case "categories": data = categories; break;
      case "products": data = products; break;
      case "tables": data = tables; break;
      case "staff": data = staff; break;
      case "extras": data = extras; break;
    }

    return (
      <div className="bg-white rounded-lg shadow-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              {activeTab === "categories" && (
                <>
                  <th className="px-6 py-3 text-left">Ad</th>
                  <th className="px-6 py-3 text-left">Sıra</th>
                </>
              )}
              {activeTab === "products" && (
                <>
                  <th className="px-6 py-3 text-left">Ad</th>
                  <th className="px-6 py-3 text-left">Kategori</th>
                  <th className="px-6 py-3 text-left">Fiyat</th>
                  <th className="px-6 py-3 text-left">Boyutlar</th>
                </>
              )}
              {activeTab === "tables" && (
                <>
                  <th className="px-6 py-3 text-left">Masa No</th>
                  <th className="px-6 py-3 text-left">Kapasite</th>
                  <th className="px-6 py-3 text-left">Durum</th>
                </>
              )}
              {activeTab === "staff" && (
                <>
                  <th className="px-6 py-3 text-left">Ad</th>
                  <th className="px-6 py-3 text-left">Rol</th>
                  <th className="px-6 py-3 text-left">Telefon</th>
                </>
              )}
              {activeTab === "extras" && (
                <>
                  <th className="px-6 py-3 text-left">Ad</th>
                  <th className="px-6 py-3 text-left">Fiyat</th>
                </>
              )}
              <th className="px-6 py-3 text-right">İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {data.map(item => (
              <tr key={item.id} className="border-t hover:bg-gray-50">
                {activeTab === "categories" && (
                  <>
                    <td className="px-6 py-4">{item.name}</td>
                    <td className="px-6 py-4">{item.order}</td>
                  </>
                )}
                {activeTab === "products" && (
                  <>
                    <td className="px-6 py-4">{item.name}</td>
                    <td className="px-6 py-4">
                      {categories.find(c => c.id === item.category_id)?.name || "-"}
                    </td>
                    <td className="px-6 py-4">{item.price} ₺</td>
                    <td className="px-6 py-4">
                      {item.sizes && item.sizes.length > 0 ? (
                        <div className="text-xs">
                          {item.sizes.map((s, idx) => (
                            <div key={idx}>{s.name}: {s.price} ₺</div>
                          ))}
                        </div>
                      ) : "-"}
                    </td>
                  </>
                )}
                {activeTab === "tables" && (
                  <>
                    <td className="px-6 py-4">{item.number}</td>
                    <td className="px-6 py-4">{item.capacity} kişi</td>
                    <td className="px-6 py-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                        item.status === "boş" ? "bg-green-100 text-green-800" :
                        item.status === "dolu" ? "bg-red-100 text-red-800" :
                        "bg-yellow-100 text-yellow-800"
                      }`}>
                        {item.status}
                      </span>
                    </td>
                  </>
                )}
                {activeTab === "staff" && (
                  <>
                    <td className="px-6 py-4">{item.name}</td>
                    <td className="px-6 py-4">
                      <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                        {item.role}
                      </span>
                    </td>
                    <td className="px-6 py-4">{item.phone || "-"}</td>
                  </>
                )}
                {activeTab === "extras" && (
                  <>
                    <td className="px-6 py-4">{item.name}</td>
                    <td className="px-6 py-4">
                      {item.size_prices && item.size_prices.length > 0 ? (
                        <div className="text-xs space-y-1">
                          {item.size_prices.map((sp, idx) => (
                            <div key={idx} className="flex items-center">
                              <span className="font-medium w-16">{sp.size}:</span>
                              <span className="text-orange-600">{sp.price} ₺</span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <span>{item.price} ₺</span>
                      )}
                    </td>
                  </>
                )}
                <td className="px-6 py-4 text-right">
                  <button
                    onClick={() => openEditModal(item)}
                    className="text-blue-600 hover:text-blue-800 mr-3"
                  >
                    <Edit size={18} />
                  </button>
                  <button
                    onClick={() => handleDelete(item.id)}
                    className="text-red-600 hover:text-red-800"
                  >
                    <Trash2 size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const handleTestPrint = async () => {
    console.log("handleTestPrint çağrıldı");
    try {
      console.log("API çağrısı yapılıyor:", `${API}/print/test`);
      const response = await axios.post(`${API}/print/test`);
      console.log("API yanıtı:", response.data);
      
      if (response.data.success) {
        alert("Test yazdırması başarılı!\n" + response.data.message);
      } else {
        alert("Test yazdırması başarısız: " + response.data.message);
      }
    } catch (error) {
      console.error("Test yazdırma hatası:", error);
      console.error("Error response:", error.response);
      alert("Yazıcı bağlantı hatası: " + (error.message || "Bilinmeyen hata"));
    }
  };

  return (
    <div className="p-8" data-testid="admin-page">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Yönetim Paneli</h1>
        <div className="flex space-x-3">
          {activeTab === "products" && (
            <button
              onClick={() => setShowPriceIncreaseModal(true)}
              className="flex items-center space-x-2 px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
            >
              <TrendingUp size={20} />
              <span>Toplu Zam (Ürünler)</span>
            </button>
          )}
          {activeTab === "extras" && (
            <button
              onClick={() => setShowExtrasPriceIncreaseModal(true)}
              className="flex items-center space-x-2 px-6 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
            >
              <TrendingUp size={20} />
              <span>Toplu Zam (Ekstralar)</span>
            </button>
          )}
          <button
            onClick={openAddModal}
            className="flex items-center space-x-2 px-6 py-3 bg-orange-600 text-white rounded-lg hover:bg-orange-700"
          >
            <Plus size={20} />
            <span>Yeni Ekle</span>
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex space-x-4 mb-6">
        {[
          { key: "categories", label: "Kategoriler" },
          { key: "products", label: "Ürünler" },
          { key: "extras", label: "Ekstra Malzemeler" },
          { key: "tables", label: "Masalar" },
          { key: "staff", label: "Personel" }
        ].map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-6 py-3 rounded-lg font-medium transition ${
              activeTab === tab.key
                ? "bg-orange-600 text-white"
                : "bg-white text-gray-700 hover:bg-gray-100"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {renderList()}

      {/* Product Edit/Add Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className={`bg-white rounded-lg p-8 ${activeTab === "products" ? "w-[700px]" : "w-96"}`}>
            <h2 className="text-2xl font-bold mb-6">
              {editingItem ? "Düzenle" : "Yeni Ekle"}
            </h2>
            {renderForm()}
            <div className="flex space-x-4 mt-6">
              <button
                onClick={() => {
                  setShowModal(false);
                  setFormData({});
                }}
                disabled={isSaving}
                className="flex-1 flex items-center justify-center space-x-2 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <X size={20} />
                <span>İptal</span>
              </button>
              <button
                onClick={handleSave}
                disabled={isSaving}
                className="flex-1 flex items-center justify-center space-x-2 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Save size={20} />
                <span>{isSaving ? "Kaydediliyor..." : "Kaydet"}</span>
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Bulk Price Increase Modal */}


      {/* Extras Bulk Price Increase Modal */}
      {showExtrasPriceIncreaseModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 w-96">
            <h2 className="text-2xl font-bold mb-6">Ekstra Malzemeler Toplu Zam</h2>
            <p className="text-gray-600 mb-4">
              Tüm ekstra malzeme fiyatlarını belirli bir oranda artırın.
            </p>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
              <p className="text-sm text-blue-800 font-semibold mb-2">Akıllı Yuvarlama:</p>
              <ul className="text-xs text-blue-700 space-y-1">
                <li>• Son rakam 1-4: Aşağı (152 → 150)</li>
                <li>• Son rakam 5: Olduğu gibi (155 → 155)</li>
                <li>• Son rakam 6-9: Yukarı (158 → 160)</li>
              </ul>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Zam Oranı (%)</label>
                <input
                  type="number"
                  step="0.01"
                  placeholder="Örn: 5"
                  value={extrasPriceIncreasePercentage}
                  onChange={(e) => setExtrasPriceIncreasePercentage(e.target.value)}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>
            </div>
            <div className="flex space-x-4 mt-6">
              <button
                onClick={() => {
                  setShowExtrasPriceIncreaseModal(false);
                  setExtrasPriceIncreasePercentage("");
                }}
                className="flex-1 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400"
              >
                İptal
              </button>
              <button
                onClick={handleExtrasBulkPriceIncrease}
                className="flex-1 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
              >
                Zam Uygula
              </button>
            </div>
          </div>
        </div>
      )}

      {showPriceIncreaseModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-8 w-96">
            <h2 className="text-2xl font-bold mb-6">Ürünler Toplu Zam</h2>
            <p className="text-gray-600 mb-4">
              Tüm ürün fiyatlarını belirli bir oranda artırın.
            </p>
            <div className="bg-green-50 border border-green-200 rounded-lg p-3 mb-4">
              <p className="text-sm text-green-800 font-semibold mb-2">Akıllı Yuvarlama:</p>
              <ul className="text-xs text-green-700 space-y-1">
                <li>• Son rakam 1-4: Aşağı (152 → 150)</li>
                <li>• Son rakam 5: Olduğu gibi (155 → 155)</li>
                <li>• Son rakam 6-9: Yukarı (158 → 160)</li>
              </ul>
            </div>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Zam Oranı (%)</label>
                <input
                  type="number"
                  step="0.01"
                  placeholder="Örn: 5"
                  value={priceIncreasePercentage}
                  onChange={(e) => setPriceIncreasePercentage(e.target.value)}
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>
            </div>
            <div className="flex space-x-4 mt-6">
              <button
                onClick={() => {
                  setShowPriceIncreaseModal(false);
                  setPriceIncreasePercentage("");
                }}
                className="flex-1 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400"
              >
                İptal
              </button>
              <button
                onClick={handleBulkPriceIncrease}
                className="flex-1 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
              >
                Zam Uygula
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPage;
